import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './Core_Data_Room.css';

const Core_Data_Room = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"CORE_DATA_ROOM",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	CORE_DATA_ROOM:-1
  });


  const [CORE_DATA_ROOM, setCORE_DATA_ROOM] = React.useState(null);
  const [CORE_DATA_ROOM_D, setCORE_DATA_ROOM_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Core Data Room');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/Core_Data_Room',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewCORE_DATA_ROOM(clientInfo,"OpenNew");

		navigate('/Core_Data_Room',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Data_Room_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(CORE_DATA_ROOM));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutCORE_DATA_ROOM(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostCORE_DATA_ROOM(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewCORE_DATA_ROOM(clientInfo,"OpenNew");
		}
		navigate('/Core_Data_Room',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Data_Room_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Data_Room_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Data_Room_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(CORE_DATA_ROOM));
		if(Temp_Data2.status!="New"){
			handleDeleteCORE_DATA_ROOM(Temp_Data2);
			navigate('/Core_Data_Room#New',{replace:true});
		} 
		else 
			navigate('/Core_Data_Room',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Data_Room',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Data_Room',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Data_Room',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Data_Room',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!CORE_DATA_ROOM) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_${i}_SECTION`;
	  const headerId = `#PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [CORE_DATA_ROOM]) ;


  
  
  var Ids = [];
  for(var Ele in CORE_DATA_ROOM){
	  for(var Sec in CORE_DATA_ROOM[Ele]){
		if(Sec == "id")
			Ids.push(CORE_DATA_ROOM[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(CORE_DATA_ROOM[Ele]["status"]);
		else if(Array.isArray(CORE_DATA_ROOM[Ele][Sec]))
			  for(var Row in CORE_DATA_ROOM[Ele][Sec])  // Convert to CORE_DATA_ROOM[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in CORE_DATA_ROOM[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["CORE_DATA_ROOM"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewCORE_DATA_ROOM(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DATA_ROOM`).then((response1) => {
		if(!CORE_DATA_ROOM) 
			setCORE_DATA_ROOM(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DATA_ROOM_D`).then((response2) => {
			setCORE_DATA_ROOM_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddCORE_DATA_ROOM_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewCORE_DATA_ROOM = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DATA_ROOM/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setCORE_DATA_ROOM(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataCORE_DATA_ROOM = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DATA_ROOM/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutCORE_DATA_ROOM = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DATA_ROOM/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostCORE_DATA_ROOM = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DATA_ROOM', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteCORE_DATA_ROOM = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DATA_ROOM', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM));
	Temp_Data["1"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_0"]=value;
	//handleAddCORE_DATA_ROOM(Temp_Data,App_Data['CORE_DATA_ROOM']);
	Form_Data_onChange("1","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_0",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM(Temp_Data);
    setCORE_DATA_ROOM(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM));
	Temp_Data["1"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_1"]=value;
	//handleAddCORE_DATA_ROOM(Temp_Data,App_Data['CORE_DATA_ROOM']);
	Form_Data_onChange("1","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_1",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM(Temp_Data);
    setCORE_DATA_ROOM(Temp_Data);
 }; 
  

const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM));
	Temp_Data["1"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_2"]=value;
	Form_Data_onChange("1","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_2",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM(Temp_Data);
    setCORE_DATA_ROOM(Temp_Data);
	//handleAddCORE_DATA_ROOM(Temp_Data,App_Data['CORE_DATA_ROOM']);
  }; 
  

    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM));
	Temp_Data["1"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_3"]=value;
	//handleAddCORE_DATA_ROOM(Temp_Data,App_Data['CORE_DATA_ROOM']);
	Form_Data_onChange("1","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_3",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM(Temp_Data);
    setCORE_DATA_ROOM(Temp_Data);
 }; 
  
  
      
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM));
	Temp_Data["2"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_0"]=value ? true : false; // optionally just use boolean
	//handleAddCORE_DATA_ROOM(Temp_Data,App_Data['CORE_DATA_ROOM']);
	Form_Data_onChange("2","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_0",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM(Temp_Data);
    setCORE_DATA_ROOM(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM));
	Temp_Data["2"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_1"]=value ? true : false; // optionally just use boolean
	//handleAddCORE_DATA_ROOM(Temp_Data,App_Data['CORE_DATA_ROOM']);
	Form_Data_onChange("2","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_1",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM(Temp_Data);
    setCORE_DATA_ROOM(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_2_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM));
	Temp_Data["2"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_2"]=value ? true : false; // optionally just use boolean
	//handleAddCORE_DATA_ROOM(Temp_Data,App_Data['CORE_DATA_ROOM']);
	Form_Data_onChange("2","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_2",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM(Temp_Data);
    setCORE_DATA_ROOM(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_3_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM));
	Temp_Data["2"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_3"]=value ? true : false; // optionally just use boolean
	//handleAddCORE_DATA_ROOM(Temp_Data,App_Data['CORE_DATA_ROOM']);
	Form_Data_onChange("2","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_3",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM(Temp_Data);
    setCORE_DATA_ROOM(Temp_Data);
 }; 
  



const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM));
	Temp_Data["3"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_3_0"]=value;
	Form_Data_onChange("3","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_3_0",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM(Temp_Data);
    setCORE_DATA_ROOM(Temp_Data);
	//handleAddCORE_DATA_ROOM(Temp_Data,App_Data['CORE_DATA_ROOM']);
  }; 
  

    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM));
	Temp_Data["4"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_4_0"]=value;
	//handleAddCORE_DATA_ROOM(Temp_Data,App_Data['CORE_DATA_ROOM']);
	Form_Data_onChange("4","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_4_0",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM(Temp_Data);
    setCORE_DATA_ROOM(Temp_Data);
 }; 
  

const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_0"]=value;
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_0",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM(Temp_Data);
    setCORE_DATA_ROOM(Temp_Data);
	//handleAddCORE_DATA_ROOM(Temp_Data,App_Data['CORE_DATA_ROOM']);
  }; 
  

    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_1"]=value;
	//handleAddCORE_DATA_ROOM(Temp_Data,App_Data['CORE_DATA_ROOM']);
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_1",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM(Temp_Data);
    setCORE_DATA_ROOM(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_2"]=value;
	//handleAddCORE_DATA_ROOM(Temp_Data,App_Data['CORE_DATA_ROOM']);
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_2",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM(Temp_Data);
    setCORE_DATA_ROOM(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_3"]=value;
	//handleAddCORE_DATA_ROOM(Temp_Data,App_Data['CORE_DATA_ROOM']);
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_3",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM(Temp_Data);
    setCORE_DATA_ROOM(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_4"]=value;
	//handleAddCORE_DATA_ROOM(Temp_Data,App_Data['CORE_DATA_ROOM']);
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_4",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM(Temp_Data);
    setCORE_DATA_ROOM(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!CORE_DATA_ROOM) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedCORE_DATA_ROOM =JSON.parse(JSON.stringify(CORE_DATA_ROOM));
  updatedCORE_DATA_ROOM[Sec] = [...updatedCORE_DATA_ROOM[Sec], newRow];
  setCORE_DATA_ROOM(updatedCORE_DATA_ROOM);
};

const handleDeleteRow = (sec,index) => {
  const updatedCORE_DATA_ROOM = JSON.parse(JSON.stringify(CORE_DATA_ROOM));
  updatedCORE_DATA_ROOM[sec].splice(index, 1);
  setCORE_DATA_ROOM(updatedCORE_DATA_ROOM);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Core Data Room`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Data Room ID`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Data Room ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_0" type="text" className="form-control" placeholder="Data Room ID" value={CORE_DATA_ROOM["1"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_0`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Data Room ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_1" type="text" className="form-control" placeholder="Asset ID" value={CORE_DATA_ROOM["1"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_1`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Token Type Code`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_2"  value={CORE_DATA_ROOM["1"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_2`]} onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_2_Change} className="form-control" name="Token Type Code"  >
						  <option value="RENT_INCOME_TOKEN">RENT_INCOME_TOKEN</option>
						  <option value="REVENUE_SHARE_TOKEN">REVENUE_SHARE_TOKEN</option>
						  <option value="SALE_PROFIT_TOKEN">SALE_PROFIT_TOKEN</option>
						  <option value="EQUITY_APPRECIATION_TOKEN">EQUITY_APPRECIATION_TOKEN</option>
						  <option value="PREFERRED_EQUITY_TOKEN">PREFERRED_EQUITY_TOKEN</option>
						  <option value="COMMON_EQUITY_TOKEN">COMMON_EQUITY_TOKEN</option>
						  <option value="DEBT_NOTE_TOKEN">DEBT_NOTE_TOKEN</option>
						  <option value="HYBRID_TOKEN">HYBRID_TOKEN</option>
						  <option value="PRE_AUCTION_POOL_TOKEN">PRE_AUCTION_POOL_TOKEN</option>
						  <option value="POST_AUCTION_TOKENIZATION">POST_AUCTION_TOKENIZATION</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Token Type Code
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '160ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Data Room Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_3" type="text" className="form-control" placeholder="Data Room Name" value={CORE_DATA_ROOM["1"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_3`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '160ch' }}>
						 {t(`Enter Data Room Name`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Public Access Enabled`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_SECTION" className="row">
			                 {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Public Access Enabled`)} <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_0_Change} 
					  checked={CORE_DATA_ROOM?.["2"]?.["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_0"] === "true" || CORE_DATA_ROOM?.["2"]?.["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_0"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Investor Access Enabled`)} <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_1_Change} 
					  checked={CORE_DATA_ROOM?.["2"]?.["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_1"] === "true" || CORE_DATA_ROOM?.["2"]?.["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_1"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_2" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Compliance Access Enabled`)} <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_2" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_2_Change} 
					  checked={CORE_DATA_ROOM?.["2"]?.["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_2"] === "true" || CORE_DATA_ROOM?.["2"]?.["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_2"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_3" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Version Locking Enabled`)} <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_3" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_3_Change} 
					  checked={CORE_DATA_ROOM?.["2"]?.["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_3"] === "true" || CORE_DATA_ROOM?.["2"]?.["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_2_3"] === true} />
					</label>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Data Room Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_3_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Data Room Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_3_0"  value={CORE_DATA_ROOM["3"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_3_0`]} onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_3_0_Change} className="form-control" name="Data Room Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Open">Open</option>
						  <option value="Locked">Locked</option>
						  <option value="Archived">Archived</option>
						  <option value="Suspended">Suspended</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Data Room Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Notes`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_4_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '2000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_4_0" type="text" className="form-control" placeholder="Notes" value={CORE_DATA_ROOM["4"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_4_0`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '2000ch' }}>
						 {t(`Enter Notes`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_0"  value={CORE_DATA_ROOM["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_0`]} onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_1" type="text" className="form-control" placeholder="Created By" value={CORE_DATA_ROOM["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_1`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_2" type="text" className="form-control" placeholder="Created At" value={CORE_DATA_ROOM["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_2`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_3" type="text" className="form-control" placeholder="Updated By" value={CORE_DATA_ROOM["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_3`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_4" type="text" className="form-control" placeholder="Updated At" value={CORE_DATA_ROOM["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_4`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default Core_Data_Room;  